import "./Grid.scss";

import { PureComponent } from "react";
import { GridNoRecords as KGridNoRecords } from "@progress/kendo-react-grid";

import type { GridNoRecordsProps as KGridNoRecordsProps } from "@progress/kendo-react-grid";

export class GridNoRecords extends PureComponent<KGridNoRecordsProps> {
  public static displayName = "KendoReactGridNoRecords";

  render() {
    return <KGridNoRecords {...this.props} />;
  }
}

export interface GridNoRecordsProps extends KGridNoRecordsProps {}
